import React from 'react';
import { Link, LinkProps } from 'react-scroll';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()({
  link: {
    cursor: 'pointer',
  },
});

type Props = Pick<LinkProps, 'to' | 'offset' | 'onClick' | 'children'>;

const AnchorLink: React.FC<Props> = ({
  children,
  to,
  offset = -76,
  onClick,
}) => {
  const { classes } = useStyles();

  return (
    <Link
      to={to}
      offset={offset}
      smooth="true"
      duration={500}
      onClick={onClick}
      className={classes.link}
    >
      {children}
    </Link>
  );
};

export { AnchorLink };
